import appLocaleData from "react-intl/locale-data/id";
import idMessages from "../locales/id_ID";

const IdLang = {
  messages: {
    ...idMessages,
  },
  locale: "id-ID",
  data: appLocaleData,
};
export default IdLang;
